/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF
import React from "react";
import { Steps } from "primereact/steps";

export default function StepsPR({ field, ...props }) {
  return <Steps {...field} {...props} />;
}
